import { IPersonaProps } from "@fluentui/react";
import { IGroup, IUser } from "@microsoft/mgt-react";

export enum PageName {
    ACCESS_MEDIATOR = "ACCESS_MEDIATOR",
    ORDER = "ORDER",
    NON_RND_USER = "NON_RND_USER",
    NOT_FOUND = "NOT_FOUND"
}

export enum ReportStatus {
    PUBLISHED = "Published",
    PENDING = "Pending",
    NOT_FOUND = "Not found",
    NO_PERMISSION = "No permission",
    NON_RND = "Non RnD",
    DELETED = "Deleted",
    DECLINED = "Declined",
}

export interface IAccessMediator {
    mode: string;
    report: any;
    oldReport: any;
    error: string,
    validation: any;
    securityClasses: any[];
    documentTypes: any[];
    status: string;
    checkBoxChecked?: boolean;
    isFirstLoad?: boolean;
    isLoading: boolean;
    isSPFOLoading: boolean;
    isROULoading: boolean;
    isLLCoordinatorLoading: boolean;
}

export interface IAccessMediatorValidator {
    fieldName: string;
    displayName: string;
    value?: any;
    checkRequired?: boolean;
    condition?: boolean;
    checkPastDate?: boolean;
    checkFutureDate?: boolean;
    minLength?: number;
    maxLength?: number;
}

export interface IProperty {
    field: string;
    value: any;
}

export interface ICommonReport {
    ReportGuid: string,
    AccessMediatorPath?: string,
    // additional_approvers -> split to another table
    // authors -> split to another table
    CorrelationId?: string,
    BlobUrl: string,
    Created: string,
    CreatedBy: IUser,
    Modified: string,
    ModifiedBy: IUser,
    Division: string,
    DocumentDate: string,
    Keywords?: string,
    AuthorDisplayName?: string,
    Department: string
    Language?: string
    LowTitle?: string
    Submitter: IUser,
    Title: string,
    UploadType: string
    UploadTypeDescription: string,
    WorkflowId?: string

    Authors: IUser[],
    AdditionalApprovers?: IUser[],
    Comment?: string,
}

export interface IThesisReport extends ICommonReport {
    Abstract: string,
    ThesisDocumentType: string,

    SecurityClass: ISecurityClass,
    NotificationUsers?: IUser[],
    CustomACL?: IUser[] | IGroup[],
    OrganizationalUnits?: IGroup[],
    AuthorizedAssociates?: IUser[],

}

export interface IRnDReport extends ICommonReport {
    DocumentNumber: string,
    ProjectNumber: string,
    Abstract: string,
    RnDDocumentType: string,
    RelForForeignTradeLegislation: number

    SecurityClass: ISecurityClass,
    NotificationUsers?: IUser[],
    CustomACL?: IUser[] | IGroup[],
    OrganizationalUnits?: IGroup[],
    AuthorizedAssociates?: IUser[],
}

export interface IPaperReport extends ICommonReport {
    AttachedUrl: string,
    DateOfConference: string,
    DateOfPublication: string,
    LocationOfConference: string,
    NameOfConference: string,
    NameOfJournal: string,
    PaperDocumentType: string,

    NotificationUsers?: IUser[],
}

export interface ILLReport extends ICommonReport {
    IQISNumber: string,
    LLReferenceNumber: string,
    PlantorBU: string,
    Process: string,
    Product: string,
}
export interface ISecurityClass {
    Id: number,
    Title: string,
    ShortTitle: string,
    LongTitle: string,
}

export interface ILowerFirstCaseMetadata {
    id?: string;
    guid?: string;
    accessMediatorPath?: string;
    correlationId?: string;
    blobUrl?: string;
    authors?: any[] | string;
    additionalApprovers?: any[];
    created?: Date;
    createdBy?: string;
    modified?: string;
    modifiedBy?: string;
    division?: string;
    documentDate?: Date;
    keywords?: string;
    authorDisplayName?: string;
    department?: string;
    language?: string;
    lowTitle?: string;
    submitter?: string;
    title?: string;
    uploadType?: string;
    uploadTypeDescription?: string;
    workflowId?: string;
    reportGuid?: string;
    status?: string;
    approvalDate?: Date;
    securityClass?: string;
    attachment?: any;
    iqisnumber?: string;
    llreferenceNumber?: string;
    plantorBu?: string;
    process?: string;
    product?: string;
    attachedUrl?: string;
    dateOfConference?: Date;
    dateOfPublication?: Date;
    locationOfConference?: string;
    nameOfConference?: string;
    nameOfJournal?: string;
    documentNumber?: string;
    projectNumber?: string;
    documentType?: string;
    relForForeignTradeLegislation?: boolean;
    authorizedAssociates?: any[];
    organizationalUnits?: any[];
    notificationUsers?: any[];
    customAcl?: any[];
    rou?: string;  // responsible of user 
    isAdminMode?: boolean;
    spfManager?: string;
    rfd?: string; // responsible for data/document
    abstract?: string;
    comment?: string;
    llDivisionAdmin?: string;
    preSelectedDepartment?: IPersonaProps[];
    preSelectedAuthorizedAssociates?: IPersonaProps[];
    preSelectedOrganizationalUnits?: IPersonaProps[];
}
